<template>
  <v-container fluid class="pa-1">
    <v-row no-gutters class="actual-state">
      <v-col class="text-xs-left pa-1" cols="12"
        >Fotos del estado actual del equipo</v-col
      >
      <v-col cols="12">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col
              class="pa-1"
              cols="3"
              v-for="(image, index) in machineImages"
              :key="index"
            >
              <v-card text tile class="actual-state__single-image" white>
                <v-container fluid fill-height class="pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template v-if="image.src" class="text-center">
                      <v-icon
                        v-if="isEditChecklist"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(index)"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="validSrcImage(image.src)"
                        class="actual-state__image"
                        alt="Image to upload"
                        @click="downloadImage(validSrcImage(image.src))"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ image.titleSection }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        v-if="isEditChecklist"
                        class="actual-state__icon"
                        color="gray"
                        @click.prevent="uploadImage(index)"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <v-icon v-else class="actual-state__icon" color="gray"
                        >visibility_off</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                      >
                        {{ image.titleSection }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row no-gutters class="actual-state" v-if="checklistPhysicalImages.src">
      <v-col class="text-xs-left pa-1" cols="12"
        >Foto de checklist Físico</v-col
      >
      <v-col cols="12">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col class="pa-1" cols="4">
              <v-card text tile class="actual-state__single-image" white>
                <v-container fluid fill-height class="pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template
                      v-if="checklistPhysicalImages.src"
                      class="text-center"
                    >
                      <v-icon
                        v-if="isEditChecklist"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteCheckPhyImage()"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="validSrcImage(checklistPhysicalImages.src)"
                        class="actual-state__image"
                        alt="Image to upload"
                        @click="
                          downloadImage(
                            validSrcImage(checklistPhysicalImages.src)
                          )
                        "
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ checklistPhysicalImages.titleSection }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        class="actual-state__icon"
                        color="gray"
                        @click.prevent="uploadImage('physical')"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                      >
                        {{ checklistPhysicalImages.titleSection }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <input
      :disabled="accessToEdit"
      v-show="false"
      ref="uploadcheck"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadcheck.files)"
    />
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { ResizeImage } from "@/services/ResizeImage";
export default {
  data() {
    return {
      currentImageIndex: ""
    };
  },
  props: ["isEditChecklist", "machineI", "checklistPhysicalI", "accessToEdit"],
  computed: {
    ...mapState("checklist", ["machineImages", "checklistPhysicalImages"])
  },
  methods: {
    validSrcImage(url) {
      if (!this.isEditChecklist) {
        if (!url) return null;
        if (url.includes("https")) return url;
        return require("@/assets/logo.png");
      }
      return url;
    },
    uploadImage(id) {
      this.currentImageIndex = id;
      this.$refs.uploadcheck.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        if (this.currentImageIndex === "physical")
          this.checklistPhysicalImages.src = resizedImage;
        else this.machineImages[this.currentImageIndex].src = resizedImage;
        this.$refs.uploadcheck.value = null;
      }
    },
    deleteAndCleanImage(id) {
      this.machineImages[id].src = null;
    },
    deleteCheckPhyImage() {
      this.checklistPhysicalImages.src = null;
    },
    downloadImage(src) {
      window.open(src, "_blank");
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    }
  }
};
</script>
<style scoped>
.actual-state {
  border: 1px solid lightgray;
}
.actual-state__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 90px;
  max-width: 200px;
  margin: 0 auto;
}
.actual-state__icon {
  padding: 1.3rem;
  margin: 0 auto;
}
.actual-state__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
}
.actual-state__image {
  max-height: 103px;
  object-fit: contain;
  margin: 0;
  height: 80%;
  padding: 0 4px;
  overflow: hidden;
  width: 100%;
}
.actual-state__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
</style>
